/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Header from "../header/header";
import Footer from "../footer/footer";
import styles from "./layout.module.scss";
import classNames from "classnames";
import { Helmet } from 'react-helmet';
import favicon from '../../assets/favicon.ico';

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleWebsiteQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const [isSticky, setSticky] = useState(false);

  function setStickyHeader() {
    if (window.scrollY > 1) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", setStickyHeader);
  });

  return (
    <>
    <Helmet link={[
      { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
  ]}>

    </Helmet>
    <div className={classNames(styles.wrapper)}>
      <div
        className={classNames(
          styles.header,
          isSticky ? styles.stickyHeader : ""
        )}
      >
        <Header siteTitle={data.site.siteMetadata.title} />
      </div>
      <main> {children} </main>
      <Footer />
    </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
